
(function documentContainerControllerDefinition() {
    'use strict';

    angular.module('DocumentContainer')
        .controller('DocumentContainerModifyController', [
            '$scope', 'config', '$state', '$translate', 'errorsExtend', '$stateParams', 'documentContainerService', 'authExtend', 'containerTypeService',
            'documentTypeService', 'fileService', '$q', 'documentService', 'documentAction', 'alerts', 'twainCapture', '$filter',
            function containerTypeController($scope, config, $state, $translate, errors, $stateParams, documentContainerService, authExtend, containerTypeService,
                documentTypeService, fileService, $q, documentService, documentAction, alerts, twainCapture, $filter) {

                twainCapture.setFileNameStartIndex();
                $scope.optionsDocumentContainer = [];
                $scope.hasNameTemplate = false;

                $scope.loadActions = function () {
                    if (!$scope.aux.container.containerTypeId) {
                        return;
                    }

                    containerTypeService.isContainertypeInRole(['DOCUMENT DIGITALIZATION'], $scope.aux.container.containerTypeId).then(function (r) { $scope.canDigitalize = r; });
                    containerTypeService.isContainertypeInRole(['FILE DOWNLOAD'], $scope.aux.container.containerTypeId).then(function (r) { $scope.downloadBtn = r; });
                    containerTypeService.isContainertypeInRole(['DOCUMENTVERSION READ'], $scope.aux.container.containerTypeId).then(function (r) { $scope.versionView = r; });
                    containerTypeService.isContainertypeInRole(['DOCUMENTVERSIONED WRITE'], $scope.aux.container.containerTypeId).then(function (r) { $scope.checkInVersioned = r; });
                    containerTypeService.isContainertypeInRole(['DOCUMENT WRITE'], $scope.aux.container.containerTypeId).then(function (r) { $scope.accesCheckIn = r; });

                    $scope.documentWrite = authExtend.isInRole('DOCUMENT WRITE') || authExtend.isInRole('DOCUMENTVERSIONED WRITE');
                }

                $scope.canAddItemsToComboMetadata = authExtend.isInRole('METADATA INSERT');

                $scope.cancel = function () {
                    $state.goBack('document-container-detail', { id: $scope.container.id });
                };

                $scope.changeAsName = function (value) {
                    if (value.updatesName) {
                        $scope.aux.document.name = value.metadataValue;
                        $scope.container.name = value.metadataValue;
                    }
                };

                $scope.loadContainerTypes = function () {
                    var defered = $q.defer();
                    var promise = defered.promise;

                    containerTypeService.getFunctionsTypes(['DOCUMENTCONTAINER WRITE']).then(function (result) {
                        $scope.optionsContainerTypes = result.sort(function (a, b) {
                            return a.name.localeCompare(b.name);
                        });
                        defered.resolve();

                    }, function (error) {
                        errors.showError(error);
                        defered.reject();
                        $scope.cancel();
                    });

                    return promise;
                };

                $scope.loadContainer = function () {
                    var defered = $q.defer();
                    var promise = defered.promise;

                    documentContainerService.getById($stateParams.id).then(function (result) {
                        $scope.aux.container = result;
                        $scope.hasNameTemplate = $scope.aux.container.containerTypeNameTemplate != null;
                        $scope.optionsDocumentContainer = [];
                        $scope.findDocuments();
                        $scope.optionsContainerTypes.push({ id: $scope.aux.container.containerTypeId, name: $scope.aux.container.containerTypeName });

                        $scope.loadActions();
                        defered.resolve();
                    }, function (error) {
                        errors.showError(error);
                        $scope.cancel();
                    });

                    return promise;
                };

                $scope.hasChanges = function () {
                    if ($scope.containerCopy.name !== $scope.container.name || $scope.containerCopy.organizationalUnitId !== $scope.container.organizationalUnitId || $scope.container.documents.length > 0)
                        return true;

                    for (var i = 0; $scope.container.metadatas.length > i; i++) {
                        if ($scope.container.metadatas[i].metadataOldValue !== $scope.container.metadatas[i].metadataValue) {
                            return true;
                        }
                    }
                    return false;
                };

                $scope.load = function () {
                    $scope.containerMetadataAsName = true;
                    $scope.title = 'DocumentContainerModify';
                    $scope.userId = authExtend.getUserId().toString();

                    $scope.data = {
                        currentPage: 1,
                        totalItems: 0,
                        itemsPerPage: 15,
                        from: 0,
                        showNoData: false
                    };

                    $translate(['PaginationNext', 'PaginationPrev', 'PaginationLast', 'PaginationFirst'])
                        .then(function (translated) {
                            $scope.paginatorTranslations = {
                                nextText: translated.PaginationNext,
                                previousText: translated.PaginationPrev,
                                lastText: translated.PaginationLast,
                                firstText: translated.PaginationFirst
                            };
                        });

                    $scope.aux = {
                        container: {},
                        files: [],
                        filesTemp: [],
                        document: {
                            name: undefined,
                            selectedDocumentTypeId: null,
                            documentTypes: []
                        },
                        metadataAsName: 0
                    };

                    $scope.container = {
                        name: '',
                        code: '',
                        containerTypeId: '',
                        containerTypeName: '',
                        parents: [],
                        metadatas: [],
                        documents: [],
                        organizationalUnitId: authExtend.getOrganizationId(),
                        organizationalUnitName: authExtend.getOrganizationName()
                    };

                    $scope.optionsContainerTypes = [];
                    $scope.optionsDocumentTypes = [];

                    $scope.preview = {
                        closed: true,
                        loading: false,
                        content: null,
                        index: null,
                        item: null,
                        invalid: false,
                        containerTab: true
                    };

                    var promesaMultipleArray = $q.all([$scope.loadContainer()]);

                    promesaMultipleArray.then(function () {
                        $scope.container.id = $scope.aux.container.id;
                        $scope.container.name = $scope.aux.container.name;
                        $scope.container.code = $scope.aux.container.code;
                        $scope.container.containerTypeId = $scope.aux.container.containerTypeId;
                        $scope.container.containerTypeName = $scope.aux.container.containerTypeName;
                        $scope.container.organizationalUnitId = $scope.aux.container.organizationalUnitId;
                        $scope.container.oldDocuments = $scope.aux.container.documents;

                        $scope.selectContainerType({ id: $scope.container.containerTypeId }, $scope.aux.container.metadatas);

                        $scope.containerCopy = angular.copy($scope.container);
                    });
                };

                $scope.removeFile = function (file) {
                    var index = $scope.getIndexFile(file);

                    if (~index) {
                        if ($scope.preview.index === index) {
                            $scope.hidePreview();
                        }
                        $scope.aux.files.splice(index, 1);
                        $scope.container.documents.splice(index, 1);
                    }
                };

                $scope.previewFile = function (item, index) {
                    $scope.preview.content = null;
                    $scope.preview.loading = true;
                    $scope.preview.closed = false;
                    $scope.preview.invalid = false;

                    fileService.preview($scope.aux.files[index], true).then(function (result) {

                        $scope.preview.content = result;

                        $scope.preview.item = item;
                        $scope.preview.index = index;
                        $scope.preview.loading = false;
                    }, function (error) {
                        if (error.data && error.data.modelState && error.data.modelState.no_converter) {
                            $scope.preview.loading = false;
                            $scope.preview.invalid = true;
                            $scope.preview.item = item;
                            $scope.preview.index = index;
                        }
                        else {
                            errors.showError(error);
                            $scope.hidePreview();
                        }
                    });

                    $scope.aux.document = $scope.container.documents[index];
                    if ($scope.optionsDocumentTypes.length === 1 && $scope.aux.document.documentTypes.length === 0) {
                        $scope.aux.document.selectedDocumentTypeId = $scope.optionsDocumentTypes[0].id;
                        $scope.selectDocumentType($scope.optionsDocumentTypes[0]);
                    } else {
                        if ($scope.aux.document.documentTypes.length === 1) {
                            $scope.aux.document.selectedDocumentTypeId = $scope.aux.document.documentTypes[0].documentTypeId;
                        }
                    }                    
                };

                $scope.hidePreview = function () {
                    $scope.aux.document.isValid = $scope.documentsForm.$valid;
                    if (!$scope.aux.document.isValid) {
                        $scope.documentsForm.$setSubmitted();
                    }

                    $scope.preview.closed = true;
                    $scope.preview.loading = false;
                    $scope.preview.content = null;
                    $scope.preview.index = null;
                    $scope.preview.invalid = false;
                    $scope.preview.item = null;
                };

                $scope.nextPreview = function () {
                    $scope.aux.document.isValid = $scope.documentsForm.$valid;
                    if (!$scope.aux.document.isValid) {
                        $scope.documentsForm.$setSubmitted();
                    }

                    if ($scope.preview.index + 1 < $scope.aux.files.length) {
                        $scope.preview.index++;
                        $scope.previewFile($scope.aux.files[$scope.preview.index], $scope.preview.index);

                        $scope.aux.document = $scope.container.documents[$scope.preview.index];
                    }
                };

                $scope.prevPreview = function () {
                    $scope.aux.document.isValid = $scope.documentsForm.$valid;
                    if (!$scope.aux.document.isValid) {
                        $scope.documentsForm.$setSubmitted();
                    }

                    if ($scope.preview.index) {
                        $scope.preview.index--;
                        $scope.previewFile($scope.aux.files[$scope.preview.index], $scope.preview.index);
                        $scope.aux.document = $scope.container.documents[$scope.preview.index];
                    }
                };

                $scope.addFile = function () {
                    $scope.aux.filesTemp.forEach(function (file) {
                        if (file && file.size) {
                            file.fsize = fileService.FormatfileSize(file.size);
                            var index = $scope.getIndexFile(file);
                            if (~index) {
                                file.documntTypesNames = $scope.aux.files[index].documntTypesNames;
                                $scope.aux.files[index] = file;
                            } else {
                                file.documntTypesNames = '';
                                $scope.aux.files.push(file);

                                var document = {
                                    name: file.name,
                                    documentTypes: [],
                                    isValid: false,
                                    selectedDocumentTypes: [],
                                    organizationalUnitId: authExtend.getOrganizationId(),
                                    metadataAsName: 0
                                }
                                $scope.container.documents.push(document);
                            }
                        }
                    });

                    $scope.aux.filesTemp = [];
                };

                $scope.getIndexFile = function (fileNew) {

                    for (var i in $scope.aux.files) {
                        if ($scope.aux.files.hasOwnProperty(i)) {
                            var fileOld = $scope.aux.files[i];

                            if (fileOld.name === fileNew.name) {
                                return i;
                            }
                        }
                    };

                    return -1;
                };

                $scope.loadDocTypeMetadata = function (documentType) {

                    var documentDocType = {
                        documentTypeName: documentType.name,
                        documentTypeId: documentType.id,
                        metadatas: []
                    };

                    $scope.aux.document.documentTypes = [];

                    if (documentType.nameTemplate) {
                        $scope.aux.document.metadataAsName++;
                    } else {
                        $scope.aux.document.metadataAsName = 0;
                    }

                    documentType.metadata.forEach(function (metadata) {
                        var replicated = $scope.getReplicatedMetadata(metadata);

                        var newMetadata = {
                            idObject: documentDocType.documentTypeId + '' + metadata.metadataId,
                            metadataId: metadata.metadataId,
                            metadataIsRequired: metadata.isRequired,
                            metadataIsUnique: metadata.isUnique,
                            metadataValue: '',
                            metadataType: metadata.metadataType,
                            metadataLabel: metadata.metadataLabel,
                            metadataOptions: metadata.optionValues,
                            maskOptions: metadata.maskOptions,
                            mask: metadata.metadataMask,
                            maskPlaceHolder: metadata.metadataMaskPlaceHolder,
                            metadataAsName: metadata.asName,
                            metadataAttributes: metadata.attributes,
                            metadataIsMultivalue: metadata.isMultivalue,
                            metadataIsUpdateable: (metadata.isUpdateable && $scope.canAddItemsToComboMetadata)
                        };

                        documentDocType.metadatas.push(newMetadata);

                        if (replicated) {
                            newMetadata.metadataReadOnly = true;
                            newMetadata.metadataValue = replicated.metadataValue;
                        }
                    });

                    $scope.aux.document.documentTypes.push(documentDocType);
                };

                $scope.loadContainerMetadata = function (type, oldValues) {
                    $scope.containerMetadataAsName = false;
                    $scope.container.containerTypeName = type.name;
                    $scope.container.metadatas = [];

                    type.metadata.forEach(function (metadata) {
                        var value = '';
                        if (oldValues) {
                            for (var i in oldValues) {
                                if (oldValues.hasOwnProperty(i)) {
                                    if (oldValues[i].metadataId === metadata.metadataId) {
                                        value = oldValues[i].metadataValue;
                                        break;
                                    }
                                }
                            };
                        }

                        var meta = {
                            idObject: type.id + '' + metadata.metadataId,
                            metadataId: metadata.metadataId,
                            metadataIsRequired: metadata.isRequired,
                            metadataIsUnique: metadata.isUnique,
                            metadataValue: value,
                            metadataOldValue: value,
                            metadataType: metadata.metadataType,
                            metadataLabel: metadata.metadataLabel,
                            metadataOptions: metadata.optionValues,
                            maskOptions: metadata.maskOptions,
                            mask: metadata.metadataMask,
                            maskPlaceHolder: metadata.metadataMaskPlaceHolder,
                            metadataReplicate: metadata.isReplicated,
                            metadataAsName: metadata.asName,
                            metadataAttributes: metadata.attributes,
                            metadataIsMultivalue: metadata.isMultivalue,
                            metadataIsUpdateable: (metadata.isUpdateable && $scope.canAddItemsToComboMetadata)
                        };

                        $scope.container.metadatas.push(meta);


                        if (metadata.asName && !$scope.containerMetadataAsName) {
                            meta.updatesName = true;
                            $scope.containerMetadataAsName = true;
                        }

                        if (metadata.isReplicated) {
                            $scope.$watch('container.metadatas[' + ($scope.container.metadatas.length - 1).toString() + '].metadataValue', function itemsChanged() {
                                $scope.replicateValues();
                            });
                        }
                    });
                }

                $scope.getReplicatedMetadata = function (metadata) {
                    for (var i = 0; $scope.container.metadatas.length > i; i++) {
                        if ($scope.container.metadatas[i].metadataReplicate && $scope.container.metadatas[i].metadataId === metadata.metadataId) {
                            return $scope.container.metadatas[i];
                        }
                    }

                    return null;
                }

                $scope.replicateValues = function () {
                    for (var i = 0; $scope.container.documents.length > i; i++) {
                        for (var k = 0; $scope.container.documents[i].documentTypes.length > k; k++) {
                            for (var l = 0; $scope.container.documents[i].documentTypes[k].metadatas.length > l; l++) {
                                var m = $scope.container.documents[i].documentTypes[k].metadatas[l];
                                var replicated = $scope.getReplicatedMetadata(m);
                                if (replicated) {
                                    m.metadataValue = replicated.metadataValue;
                                    m.metadataReadOnly = true;
                                    if (m.updatesName) {
                                        $scope.container.documents[i].name = replicated.metadataValue;
                                    }
                                }
                            }
                        }
                    }
                }

                $scope.selectContainerType = function (type, typeValues) {
                    containerTypeService.getById(type.id, 'detail').then(function (result) {
                        $scope.loadContainerMetadata(result, typeValues);

                        var containertypes = [];
                        containertypes.push(type.id);
                        documentTypeService.getByContainerId(containertypes, ['DOCUMENT WRITE', 'DOCUMENTVERSIONED WRITE']).then(function (result) {
                            $scope.optionsDocumentTypes = result.sort(function (a, b) {
                                return a.name.localeCompare(b.name);
                            });

                        }, function (error) {
                            errors.showError(error);
                            $state.go('document-find');
                        });

                    }, function (error) {
                        errors.showError(error);
                        $scope.cancel();
                    });
                }

                $scope.selectDocumentType = function (documentType) {
                    documentTypeService.getById(documentType.id, 'detail').then(function (result) {
                        $scope.loadDocTypeMetadata(result);

                        if ($scope.aux.files.length > $scope.preview.index) {
                            $scope.aux.files[$scope.preview.index].documntTypesNames = $scope.aux.document.documentTypes[0].documentTypeName;
                        }

                    }, function (error) {
                        errors.showError(error);
                        $scope.cancel();
                    });
                }

                $scope.metadataTypeCount = function () {
                    if ($scope.container.metadatas) {
                        return $scope.container.metadatas.length;
                    }

                    return 0;
                }

                $scope.view = function (document) {
                    if (!$scope.hasChanges()) {
                        return $scope.viewDocument(document);
                    } else {
                        return $translate(['Warning', 'DataLoseConfirmText', 'Yes', 'No']).then(function (translated) {
                            return alerts.confirm(translated.Warning, translated.DataLoseConfirmText, translated.Yes, translated.No).then(function getOk(result) {
                                if (result) {
                                    $scope.viewDocument(document);
                                }
                            });
                        });
                    }
                }

                $scope.viewDocument = function (document) {
                    if (document.checkedOutById != null && $scope.userId.toString() === document.checkedOutById.toString()) {
                        $state.go('mydocument-detail-container', { id: document.id, containerId: $scope.container.id });
                    } else {
                        $state.go('document-detail-container', { id: document.id, containerId: $scope.container.id });
                    }

                };

                $scope.viewPDF = function (document) {
                    if (!$scope.hasChanges()) {
                        $state.go('file-document-detail', { id: document.id, version: document.versionId });
                    } else {
                        $translate(['Warning', 'DataLoseConfirmText', 'Yes', 'No']).then(function (translated) {
                            return alerts.confirm(translated.Warning, translated.DataLoseConfirmText, translated.Yes, translated.No).then(function getOk(result) {
                                if (result) {
                                    $state.go('file-document-detail', { id: document.id, version: document.versionId });
                                }
                            });
                        });
                    }
                };

                $scope.viewVersion = function (document) {
                    if (!$scope.hasChanges()) {
                        $state.go('document-version-all', { id: document.id });
                    } else {
                        $translate(['Warning', 'DataLoseConfirmText', 'Yes', 'No']).then(function (translated) {
                            return alerts.confirm(translated.Warning, translated.DataLoseConfirmText, translated.Yes, translated.No).then(function getOk(result) {
                                if (result) {
                                    $state.go('document-version-all', { id: document.id });
                                }
                            });
                        });
                    }
                };

                $scope.modifyDoc = function (document) {
                    if (!$scope.hasChanges()) {
                        $state.go('document-modify', { id: document.id });
                    } else {
                        $translate(['Warning', 'DataLoseConfirmText', 'Yes', 'No']).then(function (translated) {
                            return alerts.confirm(translated.Warning, translated.DataLoseConfirmText, translated.Yes, translated.No).then(function getOk(result) {
                                if (result) {
                                    $state.go('document-modify', { id: document.id });
                                }
                            });
                        });
                    }
                };

                $scope.downloadFilesDocument = function (document) {
                    return documentAction.downloadFiles(document);
                }

                $scope.checkInDocument = function (document, index) {
                    
                    if (!document.documentTypes) {
                        document.documentTypes = [];
                        document.documentTypes.push({ documentTypeId: document.documentTypeId})
                    }

                    return documentAction.checkIn(document).then(function (doc) {
                        $scope.container.oldDocuments[index].checkedOutById = doc.checkedOutById;
                        $scope.container.oldDocuments[index].checkedOutByNickName = doc.checkedOutByNickName;
                    });
                };

                $scope.checkOutDocument = function (document, index) {
                    return documentAction.checkOut(document)
                        .then(function (doc) {
                            $scope.container.oldDocuments[index].checkedOutById = doc.checkedOutById;
                            $scope.container.oldDocuments[index].checkedOutByNickName = doc.checkedOutByNickName;
                        });
                };

                $scope.save = function (checkin) {
                    if (!$scope.documentContainerForm.$valid) {
                        $scope.documentContainerForm.$setSubmitted();
                        errors.showError('VerifyContainerFormData');
                        return false;
                    }



                    var hasErrors = false;
                    // Validate Metadata items
                    var comboMetadatas = $filter('filter')($scope.container.metadatas, { metadataType: 'comboKV' }, true);
                    if (comboMetadatas.length > 0) {
                        comboMetadatas.forEach(function (metadata) {
                            if (Array.isArray(metadata.metadataValue)) {
                                metadata.metadataValue.forEach(function (metadataValue) {
                                    var item = $filter('filter')(metadata.metadataOptions, { value: metadataValue, active: false }, true);
                                    if (item.length > 0) {
                                        $scope.documentContainerForm.$setSubmitted();
                                        errors.showError($translate.instant('InactiveItemMetadata', { entidad: 'Carpeta', metadataLabel: metadata.metadataLabel }));
                                        hasErrors = true;
                                        return false;
                                    }
                                });
                            } else {
                                var item = $filter('filter')(metadata.metadataOptions, { value: metadata.metadataValue, active: false }, true);
                                if (item.length > 0) {
                                    $scope.documentContainerForm.$setSubmitted();
                                    errors.showError($translate.instant('InactiveItemMetadata', { entidad: 'Carpeta', metadataLabel: metadata.metadataLabel }));
                                    hasErrors = true;
                                    return false;
                                }
                            }
                        });
                    }

                    for (var i = 0; $scope.container.documents.length > i; i++) {
                        $scope.aux.files[i].hasError = !$scope.container.documents[i].isValid;
                        if (!$scope.container.documents[i].isValid) {
                            hasErrors = true;
                        }
                    }

                    if (hasErrors) {
                        errors.showError('ContainerDocumentVerifyFormData');
                        return false;
                    }

                    if ($scope.container.documents.length <= 0) {
                        return documentContainerService.modify($scope.container, checkin).then(function (result) {
                            if (result.checkedOutById === null) {
                                $state.go('document-container-detail', { id: $scope.container.id });                            
                            } else {
                                $state.goBack('document-container-detail', { id: $scope.container.id });
                            }
                        }, function (error) {
                            errors.showError(error);
                        });
                    } else {
                        return documentContainerService.modifyWithDocuments($scope.container, $scope.aux.files).then(function () {
                            $scope.cancel();
                        }, function (error) {
                            if (error.data && error.data.modelState && error.data.modelState.error[1]) {
                                var index = error.data.modelState.error[1];
                                $scope.aux.files[index].hasError = true;
                            }

                            errors.showError(error);
                        });
                    }
                };

                $scope.beginDigitalization = function () {
                    $scope.digitalizerOpen = true;
                };

                $scope.cancelDigitalization = function () {
                    $scope.digitalizerOpen = false;
                };

                $scope.scanning = false;
                $scope.hasScannedDocument = false;

                $scope.digitalize = function () {

                    $scope.scanning = true;

                    var callback = function () {
                        twainCapture.scanOne()
                            .then(function (index) {
                                $scope.scanning = false;
                                $scope.hasScannedDocument = (twainCapture.imagesCount() !== 0);
                            }, function (error) {
                                $scope.scanning = false;
                                $scope.hasScannedDocument = (twainCapture.imagesCount() !== 0);
                                errors.showError(error);
                            });
                    };

                    twainCapture.deleteFirstImage().then(callback, callback);
                };

                $scope.addDigitalized = function () {
                    twainCapture.popImageFile()
                        .then(function (file) {
                            $scope.hasScannedDocument = (twainCapture.imagesCount() !== 0);
                            $scope.aux.filesTemp.push(file);
                            $scope.addFile();
                        }, function (error) {
                            $scope.hasScannedDocument = (twainCapture.imagesCount() !== 0);
                            errors.showError(error);
                        });
                };

                $scope.configureDigitalization = function () {
                    twainCapture.showConfigUi();
                };

                $scope.$watch(function () {
                    return twainCapture.isAvailable();
                }, function (val) {
                    $scope.digitalizerNotAvaliable = !val;
                });

                $scope.findDocuments = function () {
                    $scope.container.oldDocuments = [];
                    $scope.data.showNoData = false;


                    return documentContainerService.getDocumentsFromContainer($stateParams.id, $scope.data.currentPage, $scope.data.itemsPerPage).then(function (resultDocs) {
                        $scope.container.oldDocuments = resultDocs.value;

                        $scope.data.totalItems = resultDocs.totalCount;
                        $scope.data.from = resultDocs.from;

                        if ($scope.container.oldDocuments.length === 0) {
                            $scope.data.showNoData = true;
                        }
                    }, function (error) {
                        errors.showError(error);
                        $scope.container.oldDocuments = [];
                    });

                };

                $scope.load();
            }
        ]);
})();